import React, { useEffect, useState, useCallback, useContext } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { SESSION_STORAGE_KEY } from "../../utils/constants";
import { AppContext } from "../../context/appContext";

const QUOTE_REQUEST_LIST_URL = "https://sit48d9es3.execute-api.us-east-1.amazonaws.com/v1/orderBakeries-dev"

const CustomerQuoteRequestList = () => {
	const navigate = useNavigate();
	const { setGlobalLoading, userSub } = useContext(AppContext);
	const customerTempEmail = localStorage.getItem(SESSION_STORAGE_KEY.CAKE_APP_TEMP_EMAIL);

	const [quoteRequestList, setQuoteRequestList] = useState([]);

	const fetchQuoteRequestList = useCallback(async () => {
		if (!userSub && !customerTempEmail) {
			return;
		}
		
		try {
			setGlobalLoading(true);

			let url = QUOTE_REQUEST_LIST_URL;
			if (userSub) {
				url = `${QUOTE_REQUEST_LIST_URL}?userSub=${userSub}`;
			} else {
				url = `${QUOTE_REQUEST_LIST_URL}?guestEmail=${customerTempEmail}`;
			}

			const response = await axios.get(url);

			if (
				response.data?.data &&
				Array.isArray(response.data?.data) &&
				response.data?.data?.length > 0
			) {
				setQuoteRequestList(response.data?.data);
				setGlobalLoading(false);
			}
			setGlobalLoading(false);
		} catch (error) {
			console.error("❌ Error fetching bakeries:", error);
		}
	}, [setGlobalLoading, userSub]);

	useEffect(() => {
		fetchQuoteRequestList();
	}, [fetchQuoteRequestList]);

	const navigateToQuoteRequestDetailPage = ({ id, urlPathName }) => {
		navigate(`/c/quote-request/${id}/${urlPathName}`);
	};

	if (!userSub && !customerTempEmail) {
		return (
			<div className="text-center mt-5 pb-5">
				<h4
					style={{
						color: "#FEA2C2",
					}}>
					No quote request found
				</h4>
			</div>
		);
	}

	return (
		<Container
			className="py-5"
			style={{ position: "relative", maxWidth: "1000px" }}>
			<Row className="mb-4">
				<Col className="text-center">
					<h3>My Quote Requests:</h3>
				</Col>
			</Row>
			{quoteRequestList?.length > 0 && (
				<Table striped bordered hover>
					<thead>
						<tr>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Link
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Ref Code
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Date
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Bakery
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Product
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Price
							</th>
							<th
								style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
								Status
							</th>
						</tr>
					</thead>
					<tbody>
						{quoteRequestList?.map((q, i) => {
							return (
								<tr key={i.toString()}>
									<td>
										<span
											style={{
												textDecoration: "underline",
												color: "#0033cc",
												cursor: "pointer",
											}}
											onClick={() =>
												navigateToQuoteRequestDetailPage({
													id: q.id,
													urlPathName: q.urlPathName,
												})
											}>
											Link to Quote
										</span>
									</td>
									<td>{q.refCode}</td>
									<td>{moment(q.createdAt).format("M/DD")}</td>
									<td>{q.bakery}</td>
									<td>Cake</td>
									<td>{q.bakerPrice ? `$${q.bakerPrice}` : "N/A"}</td>
									<td
										style={{
											backgroundColor:
												q.status === "Waiting on Baker to Respond" ? "#b3ffb3" : "#fea2c2",
										}}>
										{q.status}
									</td>
								</tr>
							);
						})}
					</tbody>
				</Table>
			)}
		</Container>
	);
};

export default CustomerQuoteRequestList;
